import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import timesheetReducer from './timeSheet.slice';
import syncReducer from './sync.slice';
import dataReducer from './data.slice';
import teamReducer from './team.slice';
import { setupListeners } from '@reduxjs/toolkit/query';

const rootPersistConfig = {
  key: 'root',
  storage,
  blacklist: ['sync'], // Don't persist the sync state,
  whitelist: ['timesheets','items', 'pendingItems', 'data', "team"]
};

const rootReducer = combineReducers({
  timesheets: timesheetReducer,
  sync: syncReducer,
  data: dataReducer,
  team: teamReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.offline', 'meta.arg'],
        // Ignore these paths in the state
        ignoredPaths: ['timesheets.items.offline']
      }
    })
});
export const persistor = persistStore(store);
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
